module.exports = __webpack_public_path__ + "img/financial-cost.56b10cce.png";